module.exports = {"singular":"Auswertung","plural":"Auswertungen"};